import React from "react";

import Comand from "../../../Comand";
import Img from "../../../Img";

//Imagenes
import Img_One from "./../../../../sources/imgs/REVERSESHELL/REVERSESHELL_01.png";
import Img_Two from "./../../../../sources/imgs/REVERSESHELL/REVERSESHELL_02.png";
import Img_Three from "./../../../../sources/imgs/NMAP/NMAP_03.png";
import Img_Four from "./../../../../sources/imgs/NMAP/NMAP_04.png";
import Img_Five from "./../../../../sources/imgs/NMAP/NMAP_05.png";
import Img_Six from "./../../../../sources/imgs/NMAP/NMAP_06.png";
import Img_Seven from "./../../../../sources/imgs/NMAP/NMAP_07.png";
import Img_Eight from "./../../../../sources/imgs/NMAP/NMAP_08.png";
import Img_Nine from "./../../../../sources/imgs/NMAP/NMAP_09.png";
import Img_Ten from "./../../../../sources/imgs/NMAP/NMAP_10.png";
import Img_Eleven from "../../../../sources/imgs/NMAP/NMAP_11.png";
import Img_Twelve from "../../../../sources/imgs/NMAP/NMAP_12.png";
import Img_Thirteen from "../../../../sources/imgs/NMAP/NMAP_13.png";
import Img_Fourteen from "../../../../sources/imgs/NMAP/NMAP_14.png";
import Img_Fifteen from "../../../../sources/imgs/NMAP/NMAP_15.png";
import Img_Sixteen from "../../../../sources/imgs/NMAP/NMAP_16.png";
import Img_Seventeen from "../../../../sources/imgs/NMAP/NMAP_17.png";

import icon_directory_pink from "./../../../../sources/icons/icon-directory-pink.svg";
import icon_directory from "./../../../../sources/icons/icon-directory.svg";

export default function PRIVILEGIO_03 (props) {
    return (
        <>
            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                <span className="span-pink"> MANTENIMIENTO DE ACCESO POR ARCHIVO EN TAREA PROGRAMADA.<span className="span-pink cursor">_</span>
                </span>
            </h3>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Introducción a Mantenimiento de Acceso por archivo en tarea programada.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Una de las técnicas más versátiles para lograr persistencia en sistemas Windows es el uso del programador de tareas (Task Scheduler). Este mecanismo permite ejecutar automáticamente scripts o programas en momentos específicos, como al iniciar sesión, al encender el sistema, o incluso bajo condiciones más avanzadas.
            </p>

            <p>
                A diferencia de otras técnicas, la persistencia por tarea programada permite una ejecución sigilosa y personalizable, lo que la convierte en una opción poderosa tanto en contextos de prueba como en ataques simulados.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> ¿Qué es una Tarea Programada?<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Una tarea programada es una regla que el sistema ejecuta automáticamente bajo ciertas condiciones. Puedes definir:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        Qué ejecutar (por ejemplo, un script de PowerShell).
                    </p>
                </li>

                <li>
                    <p>
                        Cuándo ejecutarlo (por ejemplo, al iniciar sesión).
                    </p>
                </li>

                <li>
                    <p>
                        Con qué privilegios (mínimos o elevados).
                    </p>
                </li>
            </ul>  

            <p>
                Esto permite ejecutar scripts maliciosos o automatizaciones incluso sin intervención del usuario, y sin mostrar ventanas o alertas visibles.
            </p>           

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Agregar Tarea Programada.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Aquí tienes un ejemplo completo para registrar una tarea programada que ejecuta un script de manera oculta al iniciar sesión:
            </p>

            <p>
                Para <span className="span-pink">PowerShell</span>:
            </p>

            <Comand
  funcionNotificacion={props.funcionNotificacion}
  notifications={props.notifications}
  code={`$action = New-ScheduledTaskAction -Execute "powershell.exe" \`
-Argument "-ExecutionPolicy Bypass -WindowStyle Hidden -File C:\\ruta\\script.ps1"

$trigger = New-ScheduledTaskTrigger -AtLogOn

Register-ScheduledTask -TaskName "Persistencia" \`
-Action $action \`
-Trigger $trigger \`
-Description "Ejecuta script al iniciar sesión" \`
-User "$env:USERNAME" \`
-RunLevel Lowest`}
/>

            <p>
                <b className="span-blue">
                    Detalles clave:
                </b>
            </p>


            <ul className="ol-code">
                <li>
                    <p>
                        -Execute: Programa que se va a ejecutar.
                    </p>
                </li>

                <li>
                    <p>
                        -Argument: Argumentos para que el script se ejecute sin ventana y sin restricciones.
                    </p>
                </li>

                <li>
                    <p>
                        -AtLogOn: El disparador. Ejecuta la tarea cuando el usuario inicie sesión.
                    </p>
                </li>

                <li>
                    <p>
                        -RunLevel Lowest: Ejecuta con los privilegios mínimos, ideal para entornos sin privilegios de administrador.
                    </p>
                </li>
            </ul>

            <p>
                <span className="span-yellow">Nota:</span> Si estás en una shell sin derechos de administrador, el parámetro -RunLevel Lowest es necesario para que la tarea se registre correctamente. También puedes evitar usar Register-ScheduledTask y usar schtasks.exe para mayor compatibilidad.
            </p>

            <p>
                Para <span className="span-pink">CMD</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`schtasks /create /tn "Persistencia" /tr "powershell.exe -ExecutionPolicy Bypass -WindowStyle Hidden -File C:\\ruta\\script.ps1" /sc onlogon /rl lowest /f
`}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Eliminación de modificación de registro.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Para <span className="span-pink">eliminar</span> el <span className="span-white">valor agregado en la clave Run</span>:
            </p>

            <p>
                Para <span className="span-pink">PowerShell</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`Unregister-ScheduledTask -TaskName "Persistencia" -Confirm:$false`}
            />

            <p>
                Para <span className="span-pink">CMD</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`schtasks /delete /tn "Persistencia" /f`}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Visualización de modificación de registro.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Para <span className="span-pink">PowerShell</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`Get-ScheduledTask`}
            />

            <p>
                Para <span className="span-pink">CMD</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`schtasks /query /fo LIST /v`}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Conclusiones.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                La persistencia mediante tareas programadas es una técnica muy flexible, funcional incluso sin privilegios elevados, y difícil de detectar si se configura con cuidado. Es ideal para demostraciones de seguridad, entornos de laboratorio y simulaciones de ataques bajo control ético.
            </p>

            <p>
               Su uso fuera de estos contextos debe estar siempre respaldado por autorización explícita y siguiendo principios éticos de hacking responsable.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Recomendaciones.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <ul className="ol-code">
                <li>
                    <p>
                        Elige nombres discretos, como Windows Defender Service o SecurityUpdateTask.
                    </p>
                </li>

                <li>
                    <p>
                        Almacena el script en una ruta poco sospechosa, como %APPDATA%\System.
                    </p>
                </li>

                <li>
                    <p>
                        No olvides eliminar la tarea al terminar para no dejar rastros en el sistema.
                    </p>
                </li>

                <li>
                    <p>
                        Documenta tus pruebas y configura una bitácora para rastrear tus tareas creadas y eliminadas.
                    </p>
                </li>
            </ul>
        </>
    );
}